import { LOADING_DATA,SET_PONTO, SET_DATA, LOADING_EMPRESA, SET_EMPRESA} from "../types";

const initialState = {
  loading: false,
  res: [],
  empresaAtual: '',
  idEmpresa: '',
  ponto: [] 

};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        res: action.payload,
        loading: false,
      };
    case LOADING_DATA:
      return {
        ...state,
        loading: true,
      };
    case SET_EMPRESA:
      return {
        ...state,
        empresaAtual: action.payload._nomeEmpresa,
        idEmpresa: action.payload._idEmpresa,
        cnpj: action.payload._cnpj,
        razaoSocial: action.payload._razaoSocial,
        loading: false,
      }
    case LOADING_EMPRESA: 
      return {
        ...state,
        loading: true
      }
    case SET_PONTO:
      return {
        ...state,
        ponto: action.payload
      }
    default:
      return state;
  }
}
